/**
 * Categorie e slug senza dipendenze (niente zod): importabili dai componenti client del sito
 * con `@sse/schema/categories` senza portare lo schema nel bundle.
 */
/** Categorie degli eventi (riprese dal sistema v1, vedi docs/03-modello-dati.md §4). */
export const CATEGORIES = [
    'EVENTI',
    'FESTE_PATRONALI',
    'SAGRE',
    'CONCERTI',
    'TEATRI',
    'MOSTRE',
    'CINEMA',
    'FESTIVAL_CULTURALI',
    'EVENTI_DI_DANZA',
    'EVENTI_LETTERARI',
    'MERCATINI',
    'FIERE',
    'CIBO_VINO',
    'EVENTI_NATALIZI',
    'CARNEVALE',
];
/** Slug (in inglese) usato negli URL per ogni categoria. */
export const CATEGORY_SLUGS = {
    EVENTI: 'other-events',
    FESTE_PATRONALI: 'patron-saint-festivals',
    SAGRE: 'food-festivals',
    CONCERTI: 'concerts',
    TEATRI: 'theatre',
    MOSTRE: 'exhibitions',
    CINEMA: 'cinema',
    FESTIVAL_CULTURALI: 'cultural-festivals',
    EVENTI_DI_DANZA: 'dance',
    EVENTI_LETTERARI: 'literary-events',
    MERCATINI: 'markets',
    FIERE: 'fairs',
    CIBO_VINO: 'food-and-wine',
    EVENTI_NATALIZI: 'christmas',
    CARNEVALE: 'carnival',
};
//# sourceMappingURL=categories.js.map